import config from '../config';

/***********************************************************************************************************************
 *
 * @param cname
 * @param cvalue
 * @param exdays
 **********************************************************************************************************************/
export const setCookie = ( cname, cvalue, exdays ) => {
    let d = new Date();
    d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
    let expires = 'expires=' + d.toUTCString();
    // document.cookie = 'SameSite=None;';
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + ';domain=' + config().mainDomain;
    localStorage.setItem( cname, cvalue );
};


/***********************************************************************************************************************
 *
 * @param cname
 * @returns {string|boolean}
 **********************************************************************************************************************/
export const getCookie = ( cname ) => {
    let name = cname + '=';
    let ca = document.cookie.split( ';' );
    let res = '';

    for ( let i = 0 ; i < ca.length ; i++ ) {
        let c = ca[ i ];

        while ( c.charAt( 0 ) === ' ' ) {
            c = c.substring( 1 );
        }

        if ( c.indexOf( name ) === 0 ) {
            let result = c.substring( name.length, c.length );
            res = result !== 'null' ? result : '';
        }
    }

    if ( res === '' ) {
        let value = localStorage.getItem( cname );
        switch ( value ) {
            case 'false':
                return false;
            case 'true':
                return true;
            case 'null':
                return false;
            case null:
                return false;
            default:
                return value;
        }
    } else {
        return res;
    }
};


/***********************************************************************************************************************
 *
 * @param cname
 * @returns {boolean}
 ***********************************************************************************************************************/
export const checkCookie = ( cname ) => {
    if ( typeof window !== 'undefined' ) {
        let user = getCookie( cname );
        return user != '' && user !== 'null';
    } else {
        return false;
    }
};

/***********************************************************************************************************************
 *
 * @param name
 **********************************************************************************************************************/
export const deleteCookie = ( name ) => {
    setCookie( name, null, { expires: -1 } );
};